import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'appDisplayName',
  standalone: false
})
export class DisplayNamePipe implements PipeTransform {
  transform(key: string, values: { value: string; displayName: string }[]): unknown {
    if (!key || !values) {
      return '';
    }
    const found = values.find((v) => v.value === key);
    return found ? found.displayName : '';
  }
}
